import { render, staticRenderFns } from "./orderProductionSummaryPopover.vue?vue&type=template&id=23bc04bc&scoped=true&"
import script from "./orderProductionSummaryPopover.vue?vue&type=script&lang=js&"
export * from "./orderProductionSummaryPopover.vue?vue&type=script&lang=js&"
import style0 from "./orderProductionSummaryPopover.vue?vue&type=style&index=0&id=23bc04bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc04bc",
  null
  
)

export default component.exports